import { SafeArea, Image, NoticeBar } from "antd-mobile";
import Navigation from "./comp/navigation";
import Banner from "./comp/banner";
import { createUseStyles } from "react-jss";
import { isEmpty, pxToRem } from "@/util/common";
import { useEffect, useRef, useState } from "react";
import { showGlobalLoading } from "@/components/globalLoading";
import API from "@/api";
import { BannerItem, gameColumns } from "./type";
import useRouter from "@/hooks/useRouter";
import { AppDispatch, RootState } from "@/redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
	setAdminType,
	postApiFinanceBalance,
	getUserInfoMethod,
} from "@/redux/reducers/authSlice";
import { has } from "lodash";
import GiftPopup from "./comp/giftPopup";
import useCustomTranslation from "@/hooks/useTranslation";
import UserCenterPopup from "./comp/userCenterPopup";
import { isDef } from "@/util/validate";
import EvoColumn from "./comp/evoColumn";
import EvoList from "./comp/evoList";
import CustomEmpty from "@/components/Empty";
import { useGameNavigation } from "@/hooks/useGameNavigation";
import { useActivate, useUnactivate } from "react-activation";
import { useMetaMask } from "@onyx-p/metamask-react";

enum GameViewEnum {
	Home,
	Column,
	SelectAdmin,
}
const Game: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { status, account } = useMetaMask();
	const [officialServiceVisible, setOfficialServiceVisible] = useState(false);
	const [gameList, setGameList] = useState<BannerItem[]>([]);
	const [gameColumnsList, setGameColumnsList] = useState<gameColumns[]>([]);
	const [notice, setNotice] = useState<string>();
	const [gameIndex, setGameIndex] = useState<number>(0);
	const [giftVisible, setGiftVisible] = useState(false);
	const [userCenterVisible, setUserCenterVisible] = useState(false);
	const [adminShowed, setAdminShowed] = useState(false);

	const [currentView, setCurrentView] = useState<GameViewEnum>(
		GameViewEnum.Home
	);
	const gameCompanyValue = useRef("");

	const { showLoading, hideLoading } = showGlobalLoading();
	const { goToPlay } = useGameNavigation();
	const { customNavigate } = useRouter();
	const dispatch: AppDispatch = useDispatch();
	const { userInfo, loginState, nativeUser } = useSelector(
		(state: RootState) => state.auth
	);
	const { search } = useSelector((state: RootState) => state.initialization);
	const timerRef = useRef<NodeJS.Timer>();

	useEffect(() => {
		let bool = false;
		if (!isDef(userInfo)) {
			return;
		}
		const { agentType, income } = userInfo;
		const query = new URLSearchParams(search);
		if (
			agentType === 1 ||
			query.get("a") === "1" ||
			!isEmpty(income) ||
			nativeUser?.is_master
		) {
			bool = true;
		}
		setAdminShowed(bool);
	}, [userInfo]);

	// const {
	// 	prepareDeposit,
	// 	submitDeposit,
	// 	depositReady,
	// 	depositParams,
	// 	cancelDeposit,
	// } = useDeposit(1);
	// const {
	// 	prepareWithdraw,
	// 	submitWithdraw,
	// 	cancelWithdraw,
	// 	withdrawReady,
	// 	withdrawParams,
	// } = useWithdraw(1);

	useEffect(() => {
		dispatch(setAdminType(false));
		if (loginState) {
			dispatch(getUserInfoMethod());
			dispatch(postApiFinanceBalance({ itemTypes: [1] }));
			showLoading(); // 开始加载
			const fetchData = async () => {
				await Promise.all([
					loadGameList(),
					loadGameColumns(),
					loadGameNotice(),
				]);
				hideLoading(); // 完成加载
			};
			fetchData(); // 调用 fetchData 函数
		}
	}, [loginState]);

	// useEffect(() => {
	// 	let timer = setInterval(() => {
	// 		dispatch(postApiFinanceBalance({ itemTypes: [1] }));
	// 	}, 20000);
	// 	return () => {
	// 		clearInterval(timer);
	// 	};
	// }, []);

	// 封装定时器启动函数
	const startTimer = () => {
		if (timerRef.current) return;
		timerRef.current = setInterval(() => {
			dispatch(postApiFinanceBalance({ itemTypes: [1] }));
		}, 20000);
	};
	// 封装定时器清理函数
	const clearTimer = () => {
		if (timerRef.current) {
			clearInterval(timerRef.current);
			timerRef.current = undefined;
		}
	};
	// 页面激活时启动定时器
	useActivate(() => {
		startTimer();
	});
	// 页面失活时清除定时器
	useUnactivate(() => {
		clearTimer();
	});
	// 组件卸载时清理
	useEffect(() => {
		startTimer();
		return () => {
			clearTimer();
		};
	}, []);

	const loadGameList = async () => {
		const response: any = await API.games.apiAppBanner({
			type: 2,
			count: 20,
		});
		if (response?.code === 0) {
			setGameList(response.content.data);
		}
	};

	const loadGameColumns = async () => {
		const response: any = await API.games.apiGetGames({
			index: 0,
			pageSize: 20,
		});
		if (response?.code === 0) {
			setGameColumnsList(response.content?.data?.gameColumns);
		}
	};

	const loadGameNotice = async () => {
		const response: any = await API.games.apiGetGameNotice({
			source: "evo",
		});
		setNotice(response?.content?.data);
	};

	const goToPageHandle = () => {
		// 有返水
		if (has(userInfo?.balance, "3") && (userInfo?.balance["3"] ?? 0) > 0) {
			setGiftVisible(true);
		} else {
			onNavigate("personnal-receive-records");
		}
	};

	const handleSetGameCompany = (gameCompany: string) => {
		setCurrentView(GameViewEnum.Column);
		if (gameCompanyValue.current !== gameCompany)
			gameCompanyValue.current = gameCompany;
	};

	const onNavigate = (page: string) => {
		if (!isDef(userInfo)) return;
		const outerParams = {
			nickname: userInfo.nickname,
			walletAddress: userInfo.walletAddress,
			inviteRemake: "",
		};
		customNavigate(
			"/" + page + "/" + userInfo.id + "/" + JSON.stringify(outerParams)
		);
	};

	useEffect(() => {
		if (
			(status === "connected" &&
				account?.length &&
				account.toLowerCase() !==
					userInfo?.walletAddress?.toLowerCase()) ||
			status === "notConnected"
		) {
			setUserCenterVisible(false);
		}
	}, [status, account]);
	return (
		<div className="router-main">
			<SafeArea position="top" />
			<Navigation
				onWalletClick={() => customNavigate("/wallet/1")}
				onMoreClick={() => setUserCenterVisible(true)}
			/>
			{notice?.length ? (
				<NoticeBar
					style={{
						"--background-color": "#D9534F",
						"--border-color": "#D9534F",
						"--height": "36px",
					}}
					content={notice}
				/>
			) : null}
			{currentView === GameViewEnum.Home ? (
				<div
					className="router-view"
					style={{ paddingBottom: pxToRem(34) }}
				>
					<div className={classes.content}>
						{gameList.length ? (
							<Banner
								gameList={gameList}
								onIndexChange={setGameIndex}
							/>
						) : (
							<div
								style={{
									height: "30vh",
									backgroundColor: "#12141A",
								}}
							></div>
						)}
						<div className={classes.searchBarWrap}>
							<div
								onClick={() => customNavigate("/searchGame")}
								className="search"
							>
								<Image
									src={require("@/assets/images/icons/search.png")}
									className="icon"
								/>
								<span>{t("SearchGame")}</span>
							</div>
						</div>
						{gameColumnsList.length ? (
							gameColumnsList.map((item, index) => (
								<EvoColumn
									key={index}
									data={item}
									onClick={goToPlay}
									onMore={() => {
										handleSetGameCompany(item.gameCompany);
									}}
								/>
							))
						) : (
							<CustomEmpty />
						)}
					</div>
				</div>
			) : currentView === GameViewEnum.Column ? (
				<EvoList
					key={gameCompanyValue.current}
					gameCompany={gameCompanyValue.current}
					onBack={() => setCurrentView(GameViewEnum.Home)}
					onClick={goToPlay}
				/>
			) : (
				<div></div>
			)}

			{/* <OfficialServicePopup
				visible={officialServiceVisible}
				onClose={() => {
					setOfficialServiceVisible(false);
				}}
				onDepositClick={prepareDeposit}
				onWithdrawClick={prepareWithdraw}
				onRecordClick={() => {
					onNavigate("personnal-coin-records");
				}}
			/> */}

			{/* <TransactionPopup
				visible={withdrawReady}
				type={"withdraw"}
				{...withdrawParams}
				onClose={() => {
					cancelWithdraw();
				}}
				onSubmit={(_, params) => {
					return submitWithdraw(params);
				}}
			/>

			<TransactionPopup
				visible={depositReady}
				type={"deposit"}
				{...depositParams}
				onClose={() => {
					cancelDeposit();
				}}
				onSubmit={(type, params) => {
					return submitDeposit();
				}}
			/> */}

			{/* <VaultPopup
				visible={vaultVisible}
				list={vaultList}
				onClose={() => setVaultVisible(false)}
				onVaultSelect={(item) => {
					setVaultVisible(false);
					selectVault(item);
				}}
			/> */}

			<GiftPopup
				visible={giftVisible}
				onClose={() => setGiftVisible(false)}
			/>
			<UserCenterPopup
				visible={userCenterVisible}
				adminShowed={adminShowed}
				gameColumnsList={gameColumnsList}
				onClose={() => {
					setCurrentView(GameViewEnum.Home);
					setUserCenterVisible(false);
				}}
				onWalletClick={() => {
					setOfficialServiceVisible(true);
				}}
				onRewardClick={() => {
					goToPageHandle();
				}}
				onSetGameCompany={(gameCompany: string) => {
					handleSetGameCompany(gameCompany);
					setUserCenterVisible(false);
				}}
			/>
		</div>
	);
};

export default Game;

const useStyles = createUseStyles({
	content: {
		borderBottomLeftRadius: pxToRem(20),
		borderBottomRightRadius: pxToRem(20),
	},
	btn: {
		width: pxToRem(292),
		height: pxToRem(50),
		fontWeight: 700,
		fontSize: pxToRem(16),
		color: "#fff",
	},
	btn1: {
		"--border-style": "none",
		background: "linear-gradient(to right, #4675FF, #0E329D)",
	},
	searchBarWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(18),
			top: pxToRem(20),
		},
		"& .search": {
			display: "flex",
			alignItems: "center",
			color: "#868FA8",
			height: pxToRem(50),
			fontSize: pxToRem(14),
			backgroundColor: "#12141A",
			borderRadius: pxToRem(10),
			border: "1px solid #4C66C74D",
			padding: {
				left: pxToRem(16),
				right: pxToRem(16),
				bottom: pxToRem(15),
				top: pxToRem(15),
			},
			"& .icon": {
				width: pxToRem(20),
				height: pxToRem(20),
				marginRight: pxToRem(16),
			},
		},
	},
});
